"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButtons = void 0;
const react_1 = __importDefault(require("react"));
const RadioButton_1 = require("../RadioButton/RadioButton");
const RadioButtons_styles_1 = require("./RadioButtons.styles");
const RadioButtons = ({ items, selectedValue, onChange, group, direction, disabled, label, }) => {
    return (react_1.default.createElement(RadioButtons_styles_1.Container, null,
        react_1.default.createElement(RadioButtons_styles_1.Label, { "$isDisabled": disabled !== null && disabled !== void 0 ? disabled : false },
            " ",
            label,
            " "),
        react_1.default.createElement(RadioButtons_styles_1.ButtonContainer, { direction: direction !== null && direction !== void 0 ? direction : "column", disabled: disabled }, items.map((item, index) => {
            var _a;
            return (react_1.default.createElement(RadioButton_1.RadioButton, { key: index, id: `${item.value}-${index}`, label: item.label, checked: item.value === selectedValue, onChange: () => {
                    onChange(item.value);
                }, name: group, disabled: (_a = (item.disabled || disabled)) !== null && _a !== void 0 ? _a : false }));
        }))));
};
exports.RadioButtons = RadioButtons;
//# sourceMappingURL=RadioButtons.js.map